import date from "../components/inputs/date";
import Guid from "./Guid";
import {TypeAuxiliaire} from "./TypeAuxiliaire";

export enum OptionReservationModeCalcul {
    Duree,
    DureePersonne,
    Global,
    Gratuite
}

export enum OptionReservationTypeChamp {
    Logical,
    Numerique
}

export default interface IOptionReservation {
    idOptionReservation?: Guid,
    description: string,
    idAuxiliaireParent: Guid,
    typeAuxiliaire: TypeAuxiliaire,
    idAuxiliaire: Guid,
    ajoutAutomatique: boolean,
    modeCalcul: OptionReservationModeCalcul,
    quantiteMaximum: number,
    typeChamp: OptionReservationTypeChamp,
    internet: boolean,
    logiciel: boolean,
    idUsagerCreation: Guid,
    idUsagerModification: Guid,
    idUsagerSuppression?: Guid,
    dateCreation: Date,
    dateModification: Date,
    dateSuppression?: Date,
    sejourComplet: boolean,
    dateDebut?: Date,
    dateFin?: Date,
    selected?: boolean,
    quantite?: number,
    quantiteGroup?: number,
}